module.exports = __webpack_public_path__ + "img/round-menu-24px.f9147da5.svg";